// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeEnvModal_wrapper__Kg-ah","text":"ChangeEnvModal_text__dbXNL","buttons":"ChangeEnvModal_buttons__lVqCG","confirm":"ChangeEnvModal_confirm__U3PV2"};